import PropTypes from 'prop-types';

export const MINSEARCHCHAR = 3;
export const NO_WIDGET = 'no_widget';

export const UiWiseWidgetType = {
  FORM: 'form',
  TABLE_LIST: 'tableList',
  TABLE_GRID: 'tableGrid', // to be implemented
  DOC_INVOICE: 'docInvoice',
  TIMELINE: 'timeline',
  ALERT: 'alert',
};

export const UiWiseFormFieldType = {
  TEXT: 'textField',
  NUMBER: 'numberField',
  OPTION_FIELD: 'optionField',
  FILEPICKER: 'filePicker',
  IMAGEUPLOADER: 'imageUploader',
  DATEPICKER: 'datePicker',
  STARRATING: 'starRating',
  AUTOCOMPLETE: 'autocomplete',
  HIDDEN: 'hiddenField',
  DIVIDER: 'divider',
  SECTION: 'section',
  SPACER: 'spacer',
  TAG: 'tag',
};

export const UiWiseFormFieldOptionControl = {
  RADIO: 'radioGroup',
  CHECKBOX: 'checkbox',
  SWITCH: 'switchButton',
  TOGGLE_BUTTON: 'toggleButton',
  SELECT_LIST: 'selectList',
  SLIDER: 'slider',
};

export const UiWiseActionShowAsType = {
  BUTTON: 'button',
  LINK: 'link',
};

export const UiWiseActionType = {
  REDIRECT: 'redirect',
  SUBMIT: 'submit',
  RESET: 'reset',
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
  PRINT: 'print',
};

export const OptionProps = {
  label: PropTypes.string,
  value: PropTypes.any,
};

export const UiWiseFieldFormat = {
  CURRENCY: 'currency',
  PERCENTAGE: 'percentage',
  PROGRESSTEXT: 'progresstext',
  PROGRESSBAR: 'progressbar',
  DATE: 'datetype',
  BOOLEAN: 'booleantype',
  RATING: 'rating',
  NUMBER: 'number',
  NONE: 'none',
  THUMBNAIL: 'thumbnail',
};

export const UiWiseFieldSummaryCalc = {
  NONE: 'none',
  SUM: 'sum',
  COUNT: 'count',
};

export const UiWiseBooleanControl = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SWITCH: 'switchButton',
};

export const UiWiseWidgetState = {
  INIT: 'INIT',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS', // Means data is loaded/ready
  ERROR: 'ERROR',
};

export const UiWiseProgressBarFormat = [
  UiWiseFieldFormat.PROGRESSBAR,
  UiWiseFieldFormat.PROGRESSTEXT,
];
